namespace GeniuzPOS.Administration {
    export interface PsFuncKbMapKeyCodeRow {
        Id?: number;
        KbMapKeyCode?: number;
        KbMapKeyName?: string;
    }

    export namespace PsFuncKbMapKeyCodeRow {
        export const idProperty = 'KbMapKeyCode';
        export const nameProperty = 'KbMapKeyName';
        export const localTextPrefix = 'Administration.PsFuncKbMapKeyCode';
        export const lookupKey = 'Administration.PsFuncKbMapKeyCode';

        export function getLookup(): Q.Lookup<PsFuncKbMapKeyCodeRow> {
            return Q.getLookup<PsFuncKbMapKeyCodeRow>('Administration.PsFuncKbMapKeyCode');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:โปรไฟล์หลัก:Modify';

        export declare const enum Fields {
            Id = "Id",
            KbMapKeyCode = "KbMapKeyCode",
            KbMapKeyName = "KbMapKeyName"
        }
    }
}
